var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ModuleContainer,
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                _c(
                  _setup.MapControlGroupButton,
                  [
                    _vm.showCompass
                      ? _c(
                          _setup.MapControlButton,
                          {
                            attrs: {
                              title: _setup.$map.trans(
                                "map.action.navigation-control-reset-bearing"
                              ),
                            },
                            on: { click: _setup.onResetBearing },
                          },
                          [
                            _c(
                              "svg",
                              {
                                style: { transform: _setup.transform },
                                attrs: {
                                  height: "22",
                                  viewBox: "0 0 24 24",
                                  width: "22",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      fill: "none",
                                      "fill-rule": "evenodd",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: { d: "M0 0h24v24H0z" },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M12 3l4 8H8z",
                                        fill: "#f44336",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M12 21l-4-8h8z",
                                        fill: "#9E9E9E",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.showZoom
                      ? _c(
                          _setup.MapControlButton,
                          {
                            attrs: {
                              title: _setup.$map.trans(
                                "map.action.navigation-control-zoom-in"
                              ),
                            },
                            on: { click: _setup.onZoomIn },
                          },
                          [
                            _c(_setup.SvgIcon, {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _setup.path.plus,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.showZoom
                      ? _c(
                          _setup.MapControlButton,
                          {
                            attrs: {
                              title: _setup.$map.trans(
                                "map.action.navigation-control-zoom-out"
                              ),
                            },
                            on: { click: _setup.onZoomOut },
                          },
                          [
                            _c(_setup.SvgIcon, {
                              attrs: {
                                size: 18,
                                type: "mdi",
                                path: _setup.path.minus,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }